import angular from 'angular';
import _ from 'lodash';
import campaignStatusComponent from './campaignStatusComponent.html';
import './style.scss';
import logger from '../../shared/logger';

const CAMPAIGN_STATUSES = {
    NOT_STARTED: 'non_started',
    ACTIVE: 'active',
    PAUSED: 'paused',
    FINISHED: 'finished',
};

const CAMPAIGN_LABELS = {
    [CAMPAIGN_STATUSES.ACTIVE]: 'CAMPAIGN_STATUS_ACTIVE',
    [CAMPAIGN_STATUSES.PAUSED]: 'CAMPAIGN_STATUS_PAUSED',
    [CAMPAIGN_STATUSES.FINISHED]: 'CAMPAIGN_STATUS_FINISHED',
};

const VISIBLE_CAMPAIGN_STATUSES = [
    CAMPAIGN_STATUSES.ACTIVE,
    CAMPAIGN_STATUSES.PAUSED,
    CAMPAIGN_STATUSES.FINISHED,
];

export class CampaignStatusController {
    campaignStatusLabel = '';
    campaignStatus = '';
    showCampaignStatus = false;

    /* @ngInject */
    constructor(
        CampaignService,
    ) {
        this.campaignService = CampaignService;
    }

    $onChanges() {
        const { positionId } = this;

        this.getPositionStatus(positionId);
    }

    async getPositionStatus(positionId) {
        try {
            const campaignStatusResult = await this.campaignService.getCampaignStatusByPositionId(positionId);
            const campaignStatus = _.get(campaignStatusResult, 'result');

            this.campaignStatus = campaignStatus;
            this.showCampaignStatus = VISIBLE_CAMPAIGN_STATUSES.includes(campaignStatus);
            this.campaignStatusLabel = CAMPAIGN_LABELS[campaignStatus] || '';
        } catch(error) {
            logger.error(error);
        }
    }
}

export const CampaignStatusConfiguration = {
    template: campaignStatusComponent,
    bindings: {
        positionId: '<',
    },
    controller: CampaignStatusController,
    controllerAs: 'campaignStatusCtrl',
};

angular
    .module('TALENYA-FE')
    .component('campaignStatus', CampaignStatusConfiguration);
